<template>

    <div class="w-full">
        <h4 class="mb-3">EPG Provider mappings</h4>

        <div id="mappingsDiv"  class="vs-con-loading__container">

            <vs-table ref="table" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" @click="addMappingPrompt = true">Add</vs-button>

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="provider_channel_id">Provider EPG ID</vs-th>
                    <vs-th sort-key="channel_name">Channel name</vs-th>
                    <vs-th sort-key="max_days">Max Days (0 - Unlimited)</vs-th>
                    <vs-th/>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].provider_channel_id">
                            {{ data[index].provider_channel_id }}
                        </vs-td>

                        <vs-td :data="data[index].channel_name">
                            {{ data[index].channel_name }}
                        </vs-td>

                        <vs-td :data="data[index].max_days">
                            {{ data[index].max_days }}
                        </vs-td>

                        <vs-td>
                            <vs-button color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeMapping(data[index].id)"/>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </div>

        <vs-popup title="Add EPG provider mapping" :active.sync="addMappingPrompt">
            <div id="addMappingDiv" class="vs-con-loading__container" >
                <p class="mt-6">Provider EPG ID</p>
                <vs-input v-model="addObject['provider_channel_id']" class="w-full"></vs-input>
                <p class="mt-6">Max days to download (0 - Unlimited)</p>
                <vs-input v-model="addObject['max_days']" class="w-full"></vs-input>
                <p class="mt-6">Channel</p>
                <vs-select autocomplete class="w-full" v-model="addObject['channel_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in channels" />
                </vs-select>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addMapping">Add</vs-button>
            </div>
        </vs-popup>

    </div>

</template>
<script>

    export default {
        props: {
            epgProviderId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {

                itemsPerPage: 100,
                isMounted: false,

                mappings: [],
                channels: [],

                addObject: {},
                addMappingPrompt: false
            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#mappingsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/epg_provider/' + this.epgProviderId + '/mapping')
                loadPromise.then(function(response) {
                    thisIns.mappings = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const channelPromise = this.$http.get('/api/management/v1/channel/')
                channelPromise.then(function(response) {
                    thisIns.channels = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, channelPromise]).finally(function() {
                    thisIns.$vs.loading.close('#mappingsDiv > .con-vs-loading')
                })
            },
            addMapping() {
                this.$vs.loading({
                    container: '#addMappingDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/epg_provider/' + this.epgProviderId + '/mapping', {
                    provider_channel_id: this.addObject.provider_channel_id,
                    channel_id: this.addObject.channel_id,
                    max_days: Number(this.addObject.max_days)
                })

                addPromise.then(function() {
                    thisIns.addMappingPrompt = false
                    thisIns.addObject.provider_channel_id = ''
                    thisIns.addObject.channel_id = 0
                    thisIns.$printSuccess('EPG Provider mapping added')
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addMappingDiv > .con-vs-loading')
                })
            },
            removeMapping(id) {
                this.$vs.loading({
                    container: '#mappingsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const removePromise = this.$http.delete('/api/management/v1/epg_provider/' + this.epgProviderId + '/mapping/' + id)
                removePromise.then(function() {
                    thisIns.$printSuccess('EPG Provider mapping removed')
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#mappingsDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.mappings
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }
    }

</script>
